export default {
  activity: {}
}



// WEBPACK FOOTER //
// ./~/vue-components/activity-notes/store/state.js